import React from 'react';
import './Footer.css';
import logo from '../../../assets/logo3.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faLocationDot, faPhone, faEnvelope, faPaperPlane} from '@fortawesome/free-solid-svg-icons';

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-cta">
        <div className="cta-item">
        <FontAwesomeIcon icon={faLocationDot} color='#0945b4' fontSize="30px"/>
          <div className="cta-text">
            <h4>Dirección</h4>
            <span>Jr. Cruz De Piedra Nro. 315 Bar. Cumbe Mayo <br/> 
            (REF. Entré JR. Ancón) CAJAMARCA
            </span>
          </div>
        </div>
        <div className="cta-item">
            <FontAwesomeIcon icon={faPhone} color='#0945b4' fontSize="30px" />
          <div className="cta-text">
            <h4>Contactos</h4>
            <span> +51 976 492 175 </span> <br/>
            <span> +51 949 230 744 </span>

          </div>
        </div>
        <div className="cta-item">
            <FontAwesomeIcon icon={faEnvelope} color='#0945b4' fontSize="30px"  />
          <div className="cta-text">
            <h4>Correo</h4>
            <span>ventas@coberturaglobal.com.pe</span><br />
            <span>pedidos@coberturaglobal.com.pe</span>

          </div>
        </div>
      </div>

      <div className="footer-content">
        <div className="footer-widget">
          <h3>COBERTURA GLOBAL LOGISTIC MJ PERU SAC</h3>
          <p>
             Somos una empresa de distribución de productos de primera necesidad, llegamos a la 
             puerta de tu casa o de tu empresa, con la rapidez y seguridad que necesitas, siempre
             pensando en los clientes y su cuidado
          </p>
          <div className="social-icons">
            <a href="https://www.facebook.com/profile.php?id=61551049721660" target='_blank'> <FontAwesomeIcon icon={faFacebookF} className='i'/> </a>
            <a href="https://www.tiktok.com/@jtcdistribuidora..ventas" target='_blank'><FontAwesomeIcon icon={faTiktok} className='i2'/></a>
            {/* <a href="#"> <FontAwesomeIcon icon={faFacebookF} className='i3'/> </a> */}
          </div>
        </div>

        <div className="footer-widget">
          <h3>Descubre</h3>
          <ul>
            <li><Link to="/">Inicio </Link></li>
            <li><Link to="/nosotros">Nosotros</Link></li>
            <li><Link to="/productos">Productos</Link></li>
            <li><Link to="/contacto">Contactos</Link></li>
          </ul>

        </div>

        <div className="footer-logo">
          <img src={logo} alt="MJ PERU S.A.C" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
